import ExportedImage from 'next-image-export-optimizer';
import Link from 'next/link';

import * as shiki from 'shiki';
import { Tab } from '@headlessui/react';
import parse from 'html-react-parser';

import BgEllipse from '@/components/shared/lp/BgEllipse';
import CtaButton from '@/components/shared/lp/CtaButton';
import AtomicSwapPioneer from '@/components/shared/lp/developer/AtomicSwapPioneer';
import StartBuilding from '@/components/shared/lp/home/StartBuilding';

import { hack } from '@/styles/fonts';

import { siteData } from '@/data/site';
import codeBase from '@/public/images/kp/illustration/code-base.png';
import dexWallet from '@/public/images/kp/illustration/dex-wallet.png';
import runIdo from '@/public/images/kp/illustration/run-ido.png';
import komodo from '@/public/images/lp/developer/komodo.png';
import nnElections from '@/public/images/lp/developer/nn-elections.png';
import openSourceInnovation from '@/public/images/lp/developer/open-source.png';
import openSource from '@/public/images/lp/icons/service/Open-Source_Innovation.png';

export async function getStaticProps() {
  const theme = await shiki.getHighlighter({
    theme: 'css-variables',
  });

  // extract content without <pre> and <code> tags and combine code blocks into one <pre> tag for each tab
  TEXT_EDITOR_TABS.forEach((content) => {
    const combinedContent = content.commands
      .map((block) => {
        const html = theme.codeToHtml(block, { lang: 'shell' });
        const cleanHtml = html.replace(/<\/?pre[^>]*>/g, '').replace(/<\/?code[^>]*>/g, '');
        return cleanHtml;
      })
      .join('');
    content.html = `<pre><code>${combinedContent}</code></pre>`;
  });

  return {
    props: {
      textEditorTabs: JSON.parse(JSON.stringify(TEXT_EDITOR_TABS)),
    },
  };
}

export default function Developer({ textEditorTabs }) {
  return (
    <>
      <div className='absolute z-[11] h-full w-full overflow-hidden opacity-70'>
        {/* <div className='index-ellipse-1 absolute z-[-10]'></div>
      <div className='index-ellipse-2 absolute z-[-10]'></div>
      <div className='index-ellipse-3 absolute z-[-10]'></div>
      <div className='index-ellipse-4 absolute z-[-10]'></div> */}
      </div>
      <main className='container relative z-[100] mx-auto font-sans text-white md:grid md:grid-cols-24 md:gap-0'>
        <div className='lp-ellipse-223 absolute right-[0px] top-[-300px] z-[-10] h-[585px] w-[560px] -sm:top-[-500px]'></div>
        <div className='lp-ellipse-224 absolute left-[-100px] top-[163px] z-[-10] h-[515px] w-[492px] -sm:left-[-300px] -sm:top-[400px]'></div>
        <div className='lp-ellipse-232 absolute right-[-200px] top-[800px] z-[-10] h-[733px] w-[700px] -sm:right-[-300px]'></div>
        {/* <div className='lp-ellipse-233 absolute left-[-400px] top-[1700px] z-[-10] h-[783px] w-[749px]'></div>
        <div className='lp-ellipse-234 absolute right-[-300px] top-[2700px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-236 absolute right-[-300px] top-[4500px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-237 absolute left-[-400px] top-[4900px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-238 absolute right-[-300px] top-[5600px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-239 absolute left-[-300px] top-[6600px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-239 absolute right-[-300px] top-[7800px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-240 absolute left-[-300px] top-[8200px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='lp-ellipse-241 absolute right-[-300px] top-[9000px] z-[-10] h-[910px] w-[875px]'></div> */}
        <div className='lp-ellipse-239 absolute bottom-[-200px] left-[-300px] z-[-10] h-[910px] w-[875px]'></div>
        <div className='hidden xl:col-span-2 xl:block'></div>
        <div className='relative w-full max-w-7xl px-4 xs:px-8 md:col-span-24 md:mx-auto xl:col-span-20 xl:px-0'>
          <section className='relative pt-[80px] lg:pt-[150px]'>
            <div className='mx-auto flex flex-col items-center justify-center text-center'>
              <h1 className='trustless-gradient font-heading text-4xl font-semibold sm:text-5xl md:leading-[4rem] lg:text-6xl lg:leading-[4rem] 2xl:text-[73px] 2xl:leading-none 3xl:text-8xl'>
                Free Technology, Limitless Possibilities
              </h1>
              <p className='mt-4 text-center text-[14px] font-normal leading-[16px] text-white/70 lg:text-[22px] lg:leading-[24.40px]'>
                From custom blockchains to wallet apps, NFTs, and cross-platform atomic swaps,
                Komodo&apos;s all-inclusive platform gives you the tools to launch, secure, and
                scale-fast. We provide everything you need to shape the future of blockchain in one
                place.
              </p>
            </div>
            <div className='mx-auto mt-10 flex flex-row items-center justify-center'>
              <div className='pr-[38px] -sm:pr-4'>
                <Link
                  href='https://komodoplatform.com/en/docs/komodo-defi-framework/tutorials/api-walkthrough/'
                  target='_blank'
                >
                  <button className='cta-btn flex h-[42px] w-[174px] shrink-0 items-center justify-center gap-[7px] rounded-[14px] -sm:w-[160px]'>
                    <span className=''>Start Building</span>
                  </button>
                </Link>
              </div>
              <div className=''>
                <Link href='https://github.com/KomodoPlatform' target='_blank'>
                  <button className='flex h-[42px] w-[174px] shrink-0 items-center justify-center gap-[10px] rounded-[14px] bg-white px-[32px] py-[11px] -sm:w-[160px]'>
                    <span className='github-btn text-base font-bold leading-normal'>GitHub</span>
                  </button>
                </Link>
              </div>
            </div>
          </section>
          <AtomicSwapPioneer />
          <section className='relative mx-auto my-[40px] flex flex-row items-center justify-between lg:my-[100px] 2xl:my-[150px] -lg:flex-col -lg:space-y-4'>
            <Link href='https://github.com/KomodoPlatform' target='_blank' className='lg:w-[47%]'>
              <ExportedImage
                src={openSourceInnovation}
                alt='Open-Source Innovation'
                className='h-auto w-full'
              />
            </Link>
            <Link
              href='https://vote.komodoplatform.com/vote2024/'
              target='_blank'
              className='lg:w-[47%]'
            >
              <ExportedImage
                src={nnElections}
                alt='Notary Node Elections'
                className='h-auto w-full'
              />
            </Link>
          </section>
          <section className='border-bottom mt-20 py-8 md:mt-0 md:py-32'>
            <BgEllipse className='left-[-300px]' />
            <div className='mx-auto max-w-3xl pb-[2rem] text-center'>
              <div className='row justify-content-center'>
                <div className='col-lg-6'>
                  <h2 className='font-heading text-3xl font-semibold sm:text-5xl md:leading-[4rem] lg:text-6xl lg:leading-[4rem] 2xl:text-[73px] 2xl:leading-none 3xl:text-8xl'>
                    Komodo Technology Workshop
                  </h2>
                  <p className='mb-10 pt-[1rem] text-[1.1875rem] font-[400] md:text-[1.3125rem]'>
                    We are the stewards of the blockchain landscape. Find a home in the Komodo
                    workshop and learn everything you need to become a blockchain developer.
                  </p>
                </div>
              </div>
            </div>
            <div className='container-bs relative mx-auto'>
              <div className='flex flex-col justify-evenly text-center md:flex-row'>
                <div className='space-y-10' data-aos='fade-up'>
                  <h5 className='trustless-gradient text-2xl'>Getting Started</h5>
                  <ul className='space-y-7'>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href={siteData.social.discord}
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Join Komodo Discord
                      </Link>
                      <p>Become A Community Developer</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://github.com/komodoplatform'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Explore Our Repos
                      </Link>
                      <p>Browse our GitHub repos.</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Read Developer Documentation
                      </Link>
                      <p>The number one dev resource.</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/blog/komodo-ecosystem-overview/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Browse Ecosystem Projects
                      </Link>
                      <p>View the full list</p>
                    </li>
                  </ul>
                </div>
                <div className='space-y-10' data-aos='fade-up' data-aos-delay='50'>
                  <h5 className='trustless-gradient text-2xl -md:mt-10'>
                    Komodo Core Technologies
                  </h5>
                  <ul className='space-y-7'>
                    {/* <li className='col-sm-6 col-lg-12'>
                      <u>Blockchain Composer</u>
                      <i>(Coming Soon)</i>
                      <p>Launch a basic chain in 60 seconds</p>
                    </li> */}
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='http://github.com/KomodoPlatform/dPoW/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        dPoW Network
                      </Link>
                      <p>Bitcoin-level security for your network</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/smart-chains/setup/installing-from-source/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Komodo Daemon
                      </Link>
                      <p>Create a smart chain from the CLI</p>
                    </li>
                  </ul>
                </div>
                <div className='space-y-10' data-aos='fade-up' data-aos-delay='100'>
                  <h5 className='trustless-gradient text-2xl -md:mt-10'>Komodo SDK Alpha</h5>
                  <ul className='space-y-7'>
                    {/* <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/antara/api/dilithium/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Dilithium
                      </Link>
                      <p>Quantum-resistant transactions</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/antara/api/oracles/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Oracles
                      </Link>
                      <p>Off-chain data feeds</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/antara/api/gateways/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Gateways
                      </Link>
                      <p>On-chain, high speed trading</p>
                    </li> */}
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://github.com/KomodoPlatform/komodo-defi-framework'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Komodo DeFi Framework
                      </Link>
                      <p>API for modern blockchain apps</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://github.com/KomodoPlatform/komodo-wallet-desktop'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Komodo Desktop GUI
                      </Link>
                      <p>Desktop GUI for Komodo DeFi Framework</p>
                    </li>
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://github.com/KomodoPlatform/komodo-wallet-mobile'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Komodo Mobile GUI
                      </Link>
                      <p>Mobile GUI for Komodo DeFi Framework</p>
                    </li>
                    {/* <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://komodoplatform.com/en/docs/antara/api/pegs/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Pegs
                      </Link>
                      <p>Decentralized Stablecoin mechanism</p>
                    </li> */}
                    <li className='col-sm-6 col-lg-12'>
                      <Link
                        href='https://github.com/KomodoPlatform/react-komodefi-wasm'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-[#3a95ed] underline'
                      >
                        Browser(Wasm) Playground
                      </Link>
                      <p>Use Komodo DeFi Framework natively in a web browser</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>
        </div>
        <div className='hidden xl:col-span-2 xl:block'></div>
      </main>
    </>
  );
}

const TEXT_EDITOR_TABS = [
  {
    label: (...props) => (
      <p className='flex items-center justify-center gap-2'>
        <svg
          width={18}
          height={18}
          class='icon transition-all'
          xmlns='http://www.w3.org/2000/svg'
          viewBox='0 0 235.4 235.4'
          style={{ fill: '#b6bbc1' }}
        >
          <defs>
            <style></style>
          </defs>
          <title>KMD_Mark_White</title>
          <g id='Layer_2' data-name='Layer 2'>
            <g id='Layer_1-2' data-name='Layer 1'>
              <path
                class='cls-1'
                d='M0,117.7a117.7,117.7,0,0,0,235.4.45v-.9a118.33,118.33,0,0,0-3.22-26.9,12.62,12.62,0,1,0-24.56,5.85,92.5,92.5,0,1,1-68.47-68.43A12.62,12.62,0,0,0,145,3.21,117.69,117.69,0,0,0,0,117.7'
              ></path>
              <path
                class='cls-1'
                d='M177.19,31.61c-.17.16-.28.35-.44.52a18.61,18.61,0,0,0-5,11.13v0c0,.66,0,1.32,0,2,0,.46-.1.91-.15,1.37a33.61,33.61,0,0,1-41.12,29.41q-1.27-.28-2.52-.69A43.3,43.3,0,0,0,88.2,85.73c-.43.4-.9.74-1.32,1.16a43.55,43.55,0,0,0,61.59,61.59,42.65,42.65,0,0,0,4.88-5.94,43.53,43.53,0,0,0,6.66-35c-.25-.79-.45-1.57-.64-2.37,0-.12-.07-.23-.1-.35a33.63,33.63,0,0,1,29.95-41.07c.25,0,.49-.07.74-.08.71,0,1.42-.08,2.13-.08h.17a18.63,18.63,0,0,0,11.5-5.41,19.84,19.84,0,0,0,2-2.44,18.76,18.76,0,0,0-28.56-24.12'
              ></path>
            </g>
          </g>
        </svg>
        Komodo
      </p>
    ),
    commands: [
      'git clone https://github.com/KomodoPlatform/komodo',
      './zcutil/build.sh',
      './fetch-params.sh',
      './komodod',
    ],
  },
  {
    label: 'KomoDeFi',
    commands: [
      'git clone --depth=1 https://github.com/KomodoPlatform/komodo-defi-framework',
      'rustup install nightly-2022-10-29',
      'rustup default nightly-2022-10-29',
      'rustup component add rustfmt-preview',
      'cargo build --features native -vv',
    ],
  },
  {
    label: 'Desktop GUI',
    commands: ['coming soon...'],
  },
  {
    label: 'Mobile GUI',
    commands: ['coming soon...'],
  },
];
